<template>
    <el-select v-model="value" @change="changeSelect">
        <el-option
            v-for="n in memmaleList"
            :key="n.value"
            :label="n.label"
            :value="n.value"
        />
    </el-select>
</template>

<script setup>
    import {ref, onMounted, watch} from 'vue'

    const props = defineProps(['modelValue'])
    const emits = defineEmits(['update:modelValue'])

    const value = ref(null)

    const memmaleList = ref([
        {
            label: "先生",
            value: 0
        },
        {
            label: "小姐",
            value: 1
        },
        {
            label: "太太",
            value: 2
        }
    ])

    function changeSelect(e){
        emits('update:modelValue', e)
    }

    watch(() => props.modelValue, (newValue, oldValue) => {
        value.value = newValue
    })

    onMounted(() => {
        value.value = props.modelValue
    })
</script>

<style scoped>

</style>